import { useCallback } from 'react'
import { ReactFCC } from '@/types/react'
import { useTranslate } from '@/utils/translate/translate-client'
import { OptionGroup } from '../../components/OptionGroup'
import { TorchApplicationGenre } from '../../components/TorchApplicationContext'

interface TorchGenresProps {
  disabled?: boolean
  value?: string[]
  onChange: ({ name, value }: { name: string; value: string[] }) => void
  name: string
}

export const TorchGenres: ReactFCC<TorchGenresProps> = ({ disabled, name, value, onChange }) => {
  const { t } = useTranslate('guild-create')

  const genres = [
    {
      label: t('action', 'Action'),
      value: TorchApplicationGenre.Action,
    },
    {
      label: t('adventure', 'Adventure'),
      value: TorchApplicationGenre.Adventure,
    },
    {
      label: t('childrensShowMovie', "Children's Show/Movie"),
      value: TorchApplicationGenre.Children,
    },
    {
      label: t('comedy', 'Comedy'),
      value: TorchApplicationGenre.Comedy,
    },
    {
      label: t('documentary', 'Documentary/Docuseries'),
      value: TorchApplicationGenre.Documentary,
    },
    {
      label: t('drama', 'Drama'),
      value: TorchApplicationGenre.Drama,
    },
    {
      label: t('fantasy', 'Fantasy'),
      value: TorchApplicationGenre.Fantasy,
    },
    {
      label: t('history', 'History'),
      value: TorchApplicationGenre.History,
    },
    {
      label: t('improvComedy', 'Improv Comedy'),
      value: TorchApplicationGenre.Improv,
    },
    {
      label: t('musical', 'Musical'),
      value: TorchApplicationGenre.Musical,
    },
    {
      label: t('realityTV', 'Reality TV'),
      value: TorchApplicationGenre.Reality,
    },
    {
      label: t('romance', 'Romance'),
      value: TorchApplicationGenre.Romance,
    },
    {
      label: t('sciFi', 'Sci-Fi'),
      value: TorchApplicationGenre.SciFi,
    },
    {
      label: t('standupComedy', 'Standup Comedy'),
      value: TorchApplicationGenre.Standup,
    },
    {
      label: t('Thriller', 'Thriller'),
      value: TorchApplicationGenre.Suspense,
    },
  ]

  const handleChange = useCallback(
    (value: string[]) => {
      onChange({ name, value })
    },
    [name, onChange],
  )

  return (
    <OptionGroup
      label={t('torchMostApplicableGenres', 'Choose Most Applicable Genre')}
      options={genres}
      required
      disabled={disabled}
      name={name}
      value={value || []}
      onChange={handleChange}
      limit={1}
    />
  )
}
